import React, { useMemo } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import Checkbox from '../../common/checkbox/Checkbox';

const createHeaderCheckbox = (onSelectAll) => {
    const HeaderCheckbox = ({ data }) => (
        <div>
            <Checkbox
                checked={ useMemo(() => data.length && data.every(fp.identity), [data]) }
                onChange={ onSelectAll }
            />
        </div>
    );
    HeaderCheckbox.propTypes = {
        data: PropTypes.arrayOf({})
    };
    HeaderCheckbox.defaultProps = {
        data: []
    };
    return HeaderCheckbox;
};

export default createHeaderCheckbox;
